export default {
  notFoundTitle: "Page not found",
  notFoundContent: "We couldn't find the page you are looking for. Please check the URL and try again.",
  notFoundBtn: "Return to Dashboard",
  notifyWarningTitle: "Warning",
  notifyErrorTitle: "Error",
  notifyInfoTitle: "Info"
};
